import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { YOUR_PREFERENCES } from 'utils/constants/tour';
import { EventCollapse } from 'components/EventCollapse';
import { GlobalIcon } from 'components/GlobalIcon';
import { Favorite } from 'components/Shared/Favorites/Favorite';
import { clearAllFavorite } from 'store/actions';
import {
  getCollaspsedFavoriteBar,
  getFavoriteEntitiesCount,
  getFavoriteMatchIdsLoading
} from 'store/selectors/fav-data';

type TFavoriteSideBarSectionProps = {
  favoriteHighlight?: boolean;
  classNames?: { [key: string]: boolean };
};

export const FavoriteSideBarSection = ({
  classNames,
  favoriteHighlight = true
}: TFavoriteSideBarSectionProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isFavoriteMatchIdsLoading = useSelector(getFavoriteMatchIdsLoading);
  const count = useSelector(getFavoriteEntitiesCount).sportsWithCompetitions;

  const collaspsedFavoriteBar = useSelector(getCollaspsedFavoriteBar);

  const leftSidebarFavDefaultActive =
    SpringConfigs.USER_PERSONALIZATION_ENABLED && !!count;

  const clearAllFavorites = (e: SyntheticEvent) => {
    e.stopPropagation();
    dispatch(clearAllFavorite('sports'));
    dispatch(clearAllFavorite('competitions'));
  };

  return (
    <div
      id="left-sidebar-favorite__wrapper"
      className={cc([
        'left-sidebar-favorite__wrapper',
        { ...(classNames || {}) }
      ])}
      data-testid="favorite"
      {...(SpringConfigs.USER_PERSONALIZATION_ENABLED
        ? { 'data-tour': YOUR_PREFERENCES }
        : {})}
    >
      <EventCollapse
        {...(SpringConfigs.USER_PERSONALIZATION_ENABLED && favoriteHighlight
          ? { wrapperClassName: 'favorite__highlight' }
          : {})}
        title={`${
          SpringConfigs.USER_PERSONALIZATION_ENABLED
            ? t('generic.yourPreferences')
            : t('sportsbook.favorites')
        } ${isFavoriteMatchIdsLoading ? '-' : `(${count})`}`}
        defaultActive={
          leftSidebarFavDefaultActive || collaspsedFavoriteBar || false
        }
        key="0-favorites"
        icon={
          <GlobalIcon
            lib="sports"
            name="favorite"
            className="text-color"
            size={EIconSize._24}
          />
        }
        extra={
          count ? (
            <div
              data-testid="clear-all"
              className="favorite__clear-all"
              onClick={clearAllFavorites}
            >
              {t('sportsbook.clearAll')}
            </div>
          ) : (
            ''
          )
        }
        size="middle"
      >
        {count ? (
          <Favorite />
        ) : (
          <div className="click__add-favorite-container">
            <span className="click__add-favorite">
              {t('sportsbook.clickToAddFavorite')}
            </span>
          </div>
        )}
      </EventCollapse>
    </div>
  );
};
